/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import { getCountryCallingCode } from "react-phone-number-input/input";
import VerifyPhoneModal from "./VerifyPhoneModal";
import { Modal } from "./SettingsDashboard";
import toast from "react-hot-toast";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import Button from "@mui/material/Button";
import { verifyOtpApi, sendOtpApi } from "../../api/mobileVerify-api";
import axios from "axios";
import { base_URL } from "../../config/config";
import { useQueryClient } from "@tanstack/react-query";


function EditLoginDetails({
  loginDetails,
  setLoginDetails,
  user,
  setLoginModal,
  handleLoginSave,
}) {
  // const [country, setCountry] = useState("AE");
  // const [countryCode, setCountryCode] = useState("+971");

  const [mobileno, setMobileno] = useState("");
  const [country, setCountry] = useState("AE"); // Default country
  const [countryCode, setCountryCode] = useState("+971"); // Default UAE country code
  const [otpSent, setOtpSent] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [resendIn, setResendIn] = useState(0);
  const [mobileError, setMobileError] = useState("");
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!otpSent || resendIn <= 0) return;

    const t = setInterval(() => setResendIn((s) => s - 1), 1000);

    return () => clearInterval(t);
  }, [otpSent, resendIn]);

  useEffect(() => {
    const phoneData = splitPhoneNumber(user?.phone);
    handleCountryChange(phoneData.country)
    handlePhoneChange(user.phone)

  }, [user._id])

  const handleCountryChange = (countryCode) => {
    if (countryCode) {
      setCountry(countryCode);

      try {
        // Directly get the calling code for the selected country
        const dialCode = getCountryCallingCode(countryCode);
        setCountryCode(`+${dialCode}`);

        // If no number is entered, set a placeholder with the new country code
        if (!loginDetails?.mobileNumber) {
          setLoginDetails({
            ...loginDetails,
            mobileNumber: `+${dialCode}`,
          });
        }
      } catch (error) {
        console.error("Error getting country calling code:", error);
        setCountryCode("+");
      }
    }
  };



  const handleMobileNumberChange = (value) => {
    console.log(value, "number is this");
    setLoginDetails({
      ...loginDetails,
      mobileNumber: value,
    });
  };

  const updateMobileData = async (value) => {
    const response = await axios.post(
      `${base_URL}/api/dashboard/updateMobileNumber`,
      {
        vendorId: user._id,
        mobileNo: value
      }
    );
    if (response?.success) toast.success("Mobile updated successfully.")
    setLoginModal(false);
    queryClient.invalidateQueries({
      queryKey: ["user", user._id],
    });
  }

  const saveLoginDetails = (e) => {
    e.preventDefault();
    const phoneNumber = parsePhoneNumberFromString(
      String(loginDetails.mobileNumber),
      country
    );
    if (!phoneNumber || !phoneNumber.isValid()) {
      toast.error("Please enter a valid phone number");
      return;
    } else {
      // handleLoginSave(e);
      updateMobileData(loginDetails.mobileNumber)

    }
  };

  const handlePhoneChange = (value) => {
    setMobileno(value || "");
    if (!value) {
      setMobileError("Mobile number is required.");
      return;
    }
    try {
      const parsedNumber = parsePhoneNumberFromString(value, country);
      if (!parsedNumber || !parsedNumber.isValid()) {
        setMobileError("Invalid mobile number for the selected country.");
      } else {
        setMobileError(""); // Clear error if valid
      }
    } catch (error) {
      setMobileError("Invalid phone number format.");
    }
  };

  function splitPhoneNumber(fullPhone) {
    const phoneNumber = parsePhoneNumberFromString(fullPhone);

    if (!phoneNumber) return null;

    return {
      countryCode: `+${phoneNumber.countryCallingCode}`,
      nationalNumber: phoneNumber.nationalNumber,
      country: phoneNumber.country,
    };
  };

  const sendOtp = async () => {
    if (mobileError || !mobileno) {
      toast.error("Enter a valid mobile number first");

      return;
    }

    try {
      setOtpLoading(true);
      // console.log(" Sending OTP");
      const res = await sendOtpApi(mobileno);
      if (res.status !== 'pending') throw new Error('Failed to send OTP');
      setOtpSent(true);

      setOtpVerified(false);

      setResendIn(45);

      toast.success("OTP sent");
    } catch (err) {
      const msg = err.response?.data?.error ?? err.message ?? 'Failed to send OTP';
      toast.error(msg);
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyOtp = async () => {

    if (!otpCode) return toast.error("Enter the OTP");

    try {
      setOtpLoading(true);
      const verifyData = {
        to: mobileno,
        code: otpCode,
      };

      // console.log(" I am here ");
      const res = await verifyOtpApi(verifyData);

      if (res.valid) {
        setOtpVerified(true);
        handleMobileNumberChange(mobileno);
        toast.success("Phone verified ✅");
      } else {
        setOtpVerified(false);

        toast.error("Invalid OTP");
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setOtpLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={saveLoginDetails}>
        <div className="space-y-4 w-[400px] mx-auto">
          <h2 className="text-center font-bold mb-4 text-[22px] lg:text-[32px]">
            Edit Mobile Number
          </h2>

          {/* Mobile Number Input */}
          {/* <div className="relative"> */}
          {/* <div className="absolute left-[60px] top-1/2 transform   z-10 pointer-events-none">
              {countryCode}
            </div> */}
          {/* <label
              htmlFor=""
              className="relative  font-outfit text-[14px] font-normal text-[#5E5E5E]"
            >
              Mobile Number
            </label>
            <PhoneInput
              id="mobile-input"
              placeholder="123 456 7890"
              value={loginDetails?.mobileNumber || ""}
              defaultCountry="AE"
              withCountryCallingCode={true}
              autoComplete="on"
              onCountryChange={handleCountryChange}
              onChange={handleMobileNumberChange}
              style={{
                border: "1px solid #d1d5db",
                boxShadow: "none",
                borderRadius: "10px",
                outline: "none",
                width: "100%",
                padding: "0.5rem",
                // marginTop: "0.3rem",
              }}
              className="no-focus-border  "
            /> */}
          {/* </div> */}
          <div className=" w-full mb-4">
            <div className="relative">
              <div className="absolute left-[60px] top-1/2 transform   z-10 pointer-events-none">
                {countryCode || user?.phone}
              </div>
              <label
                htmlFor=""
                className="relative text-[#5E5E5E] font-outfit text-[16px] font-[300]"
              >
                Mobile No.
              </label>
              <PhoneInput
                id="mobile-input"
                placeholder="Enter your contact no."
                value={mobileno}
                defaultCountry="AE"
                withCountryCallingCode={true}
                autoComplete="on"
                onCountryChange={handleCountryChange}
                onChange={handlePhoneChange}
                style={{
                  border: "1px solid #d1d5db",
                  boxShadow: "none",
                  borderRadius: "10px",
                  outline: "none",
                  width: "100%",
                  padding: "0.5rem",
                  // marginTop: "0.3rem",
                }}
                className="no-focus-border  "
              />
            </div>
            <span className="text-red-400 text-sm">{mobileError}</span>
            <div className="flex items-center gap-2 mt-2">
              <Button
                variant="outlined"
                size="small"
                onClick={() => sendOtp("sms")} // or 'whatsapp'
                disabled={
                  otpLoading ||
                  !mobileno ||
                  !!mobileError ||
                  resendIn > 0
                }
                sx={{ textTransform: "none" }}
              >
                {resendIn > 0
                  ? `Resend in ${resendIn}s`
                  : otpSent
                    ? "Resend OTP"
                    : "Send OTP"}
              </Button>

              <input
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="Enter OTP"
                value={otpCode}
                onChange={(e) =>
                  setOtpCode(e.target.value.replace(/\D/g, ""))
                }
                className="border rounded px-3 py-1 w-28"
                disabled={!otpSent || otpVerified}
              />

              <Button
                variant="contained"
                size="small"
                onClick={verifyOtp}
                disabled={
                  !otpSent || otpVerified || !otpCode || otpLoading
                }
                sx={{ textTransform: "none" }}
              >
                {otpVerified ? "Verified" : "Verify"}
              </Button>
            </div>

            {otpVerified && (
              <span className="text-green-600 text-sm">
                Phone verified
              </span>
            )}
          </div>

          {/* Save Button */}
          <div className="flex justify-center mt-[40px]">
            {/* <button
              type="submit"
              className="active:opacity-55 bg-[#FF3939] mt-[40px] text-white w-full py-2 rounded-xl"
              disabled={!otpVerified}
            >
              Save
            </button> */}

            <button
              type="submit"
              disabled={!otpVerified}
              className="
    mt-[40px] w-full py-2 rounded-xl text-white
    bg-[#FF3939] active:opacity-55
    disabled:bg-gray-400 disabled:cursor-not-allowed disabled:opacity-70
  "
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default EditLoginDetails;
